import GetBusinessUnitByPostalCodeRequestModelBase from '../_generated/modelBases/get-business-unit-by-postal-code-request-model-base';

export default class GetBusinessUnitByPostalCodeRequestModel extends GetBusinessUnitByPostalCodeRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
